// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sub-account-password-dialog .title[data-v-51a716e0]{color:#000}.sub-account-password-dialog[data-v-51a716e0] .el-input{width:300px}", ""]);
// Exports
module.exports = exports;
